export const TRACK_DATA_CONSTANTS = {
  SOURCE: 'web',
  DEFAULT_EMAIL: 'segment-event-web@modak.live',
  MOBILE: 'mobile',
} as const;

export const VERIFY_CODE_FROM_PAGE = {
  SIGNUP: 'signup',
  SIGNIN: 'signin',
} as const;
